import { forwardRef } from 'react';
import { ConversationBanned } from '@/components/conversations/conversation-banned';
import { ConversationForm, type ConversationInputForwardedProps } from '@/components/conversations/conversation-form';
import ConversationMultiSelectBar from '@/components/conversations/conversation-multi-select-bar';
import useConversationStore from '@/hooks/conversations/use-conversation-store';

export interface ConversationBottomBarProps {
  layout?: 'full' | 'mini';
  isLoading: boolean;
  disabled?: boolean;
}

export const ConversationBottomBar = forwardRef<ConversationInputForwardedProps, ConversationBottomBarProps>(
  ({ layout, isLoading, disabled }, ref) => {
    const { multiselectAction } = useConversationStore();

    return (
      <div className='flex justify-center'>
        {multiselectAction !== null ? (
          <ConversationMultiSelectBar />
        ) : disabled ? (
          <ConversationBanned isLoading={isLoading} />
        ) : (
          <ConversationForm
            ref={ref}
            layout={layout}
            isLoading={isLoading}
            disabled={disabled}
          />
        )}
      </div>
    );
  },
);

ConversationBottomBar.displayName = 'ConversationBottomBar';
